import {Tabs, Tab, TabTitleText} from '@patternfly/react-core';
import {useSearchParams, useNavigate, useLocation} from 'react-router-dom';
import {useState} from 'react';
import Details from './Details/Details';
import SecurityReport from './SecurityReport/SecurityReport';
import {ModelCard} from './ModelCard/ModelCard';
import {Tag, ManifestByDigestResponse} from 'src/resources/TagResource';
import {TabIndex} from './Types';
import {Packages} from './Packages/Packages';
import {Layers} from './Layers/Layers';
import {useQuayConfig} from 'src/hooks/UseQuayConfig';

// Return the tab as an enum or null if it does not exist
function getTabIndex(tab: string) {
  if (Object.values(TabIndex).includes(tab as TabIndex)) {
    return tab as TabIndex;
  }
}

export default function TagTabs(props: TagTabsProps) {
  const quayConfig = useQuayConfig();

  const [activeTabKey, setActiveTabKey] = useState<TabIndex>(TabIndex.Details);
  const navigate = useNavigate();
  const location = useLocation();

  // Navigate to the correct tab
  const [searchParams] = useSearchParams();
  const requestedTabIndex = getTabIndex(searchParams.get('tab'));
  if (requestedTabIndex && requestedTabIndex !== activeTabKey) {
    setActiveTabKey(requestedTabIndex);
  }

  return (
    <Tabs
      activeKey={activeTabKey}
      onSelect={(e, tabIndex) => {
        navigate(`${location.pathname}?tab=${tabIndex}`);
      }}
      usePageInsets={true}
    >
      <Tab
        eventKey={TabIndex.Details}
        title={<TabTitleText>Details</TabTitleText>}
      >
        <Details
          org={props.org}
          repo={props.repo}
          tag={props.tag}
          digest={props.digest}
        />
      </Tab>
      <Tab
        eventKey={TabIndex.Layers}
        title={<TabTitleText>Layers</TabTitleText>}
      >
        <Layers org={props.org} repo={props.repo} digest={props.digest} />
      </Tab>
      <Tab
        eventKey={TabIndex.SecurityReport}
        title={<TabTitleText>Security Report</TabTitleText>}
        isHidden={!quayConfig?.features?.SECURITY_SCANNER}
      >
        <SecurityReport
          org={props.org}
          repo={props.repo}
          digest={props.digest}
        />
      </Tab>
      <Tab
        eventKey={TabIndex.Packages}
        title={<TabTitleText>Packages</TabTitleText>}
        isHidden={!quayConfig?.features?.SECURITY_SCANNER}
      >
        <Packages
          org={props.org}
          repo={props.repo}
          digest={props.digest}
          layers={props.manifestData?.layers}
        />
      </Tab>
      <Tab
        eventKey={TabIndex.ModelCard}
        title={<TabTitleText>Model Card</TabTitleText>}
        isHidden={!quayConfig?.features?.UI_MODELCARD || !props.tag.modelcard}
      >
        <ModelCard modelCard={props.tag.modelcard} />
      </Tab>
    </Tabs>
  );
}

type TagTabsProps = {
  tag: Tag;
  org: string;
  repo: string;
  digest: string;
  manifestData: ManifestByDigestResponse | null;
  err: string;
};
